import { render, staticRenderFns } from "./CaseViking.vue?vue&type=template&id=4ed16acf&lang=pug"
import script from "./CaseViking.vue?vue&type=script&lang=js"
export * from "./CaseViking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports